import { queryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/util/fetchClient';

export interface UnreadCounts {
  hasAnyUnread: boolean;
  unreadConversationsCount: number;
  unreadByTab: {
    all: number;
    open: number;
    closed: number;
  };
}

/**
 * Unread counts for the whole inbox, inquiries and support threads together,
 * per tab. The API decides which tab a support thread counts toward and drops
 * it under a cancer filter, so the counts match the lists without client rules.
 */
export async function getUnreadInquiriesV2(cancerTypeId?: number): Promise<UnreadCounts> {
  const { data } = await fetchClient.GET('/v2/conversations/unread', {
    params: {
      query: cancerTypeId ? { cancerTypeId } : undefined,
    },
  });

  return (
    data?.data ?? {
      hasAnyUnread: false,
      unreadConversationsCount: 0,
      unreadByTab: { all: 0, open: 0, closed: 0 },
    }
  );
}

/**
 * React Query options for the inbox's unread counts. Invalidated by the Twilio
 * listeners for inquiries and by the inbox socket for support threads.
 */
export const getUnreadInquiriesV2QueryOptions = (
  userId: string | undefined,
  cancerTypeId?: number
) =>
  queryOptions({
    queryKey: ['unreadInquiries', userId, cancerTypeId ?? 'all'],
    queryFn: () => getUnreadInquiriesV2(cancerTypeId),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
